export class SpocChangeRequest {
  ApplicationIds: string[];
  MuteNotification: boolean;
  NewInitialSPOCUserName: string;
}
